/* eslint-disable */
export default {
  namespaced: true,
  state: {
    videoRooms: [],
    videoRoomParticipants: {},
    videoRoomCreated: {},
    videoRoomWidgetBootstraped: false,
    videoRoomMediaSettings: {},
    videoVisibilityStatus: {},
  },
  getters: {
    videoRooms: (state) => state.videoRooms,
    videoRoomParticipants: (state, roomId) => state.videoRoomParticipants[roomId] === null ? 0 : state.videoRoomParticipants[roomId],
    videoRoomCreated: (state) => state.videoRoomCreated,
    videoRoomWidgetBootstraped: (state) => state.videoRoomWidgetBootstraped,
    videoRoomMediaSettings: (state) => state.videoRoomMediaSettings,
    videoVisibilityStatus: (state) => state.videoVisibilityStatus,
  },
  mutations: {
    addParticipant: (state, data) => {
      const roomId = data.room_id;
      const index = state.videoRooms.findIndex(room => room.room_id === roomId);
      if (index !== -1) {
        if (!state.videoRooms[index].participants)
          state.videoRooms[index].participants = [];
        
        state.videoRooms[index].participants.push(data.callback_data);
      }
    },
    removeParticipant: (state, data) => {
      const roomId = data.room_id;     
      const index = state.videoRooms.findIndex(room => room.room_id === roomId);
      if (index !== -1) {
        const participants = state.videoRooms[index].participants;
        if (participants) {
          const participantIndex = participants.findIndex(p => p.ParticipantSid === data.callback_data.ParticipantSid);
          if (participantIndex !== -1)
            state.videoRooms[index].participants.splice(participantIndex, 1);
        }
      }
    },    
    upsertVideoRoom: (state, videoRoom) => {
      const index = state.videoRooms.findIndex(room => room.room_id === videoRoom.room_id);
      if (index !== -1) {
        state.videoRooms.splice(index, 1, {...state.videoRooms[index], ...videoRoom});
      } else {
        state.videoRooms.unshift(videoRoom);
      }
    },
    setVideoRoomCreated(state, data) {
      const { conversationId, status } = data;
      state.videoRoomCreated[`${conversationId}`] = status;
    },
    setVideoRoomWidgetBootstraped(state, value) {
      state.videoRoomWidgetBootstraped = value;
    },
    setVideoRoomMediaSettings(state, { conversationId, settings }) {
      if (!state.videoRoomMediaSettings[conversationId]) {
        state.videoRoomMediaSettings[conversationId] = {};
      }
      state.videoRoomMediaSettings[conversationId] = { ...state.videoRoomMediaSettings[conversationId], ...settings };
    },
    clearVideoRoomMediaSettings(state, conversationId) {
      state.videoRoomMediaSettings[conversationId] = null;
    },
    updateVideoVisibilityStatus(state, { identity, visibility }) {
      state.videoVisibilityStatus = {
        ...state.videoVisibilityStatus,
        [identity]: visibility
      };
    }
  }
};